import React from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faArrowRight,
  faPalette,
  faDownload,
  faBolt,
} from '@fortawesome/free-solid-svg-icons'
import AnimatedLogoPreview from './components/AnimatedLogoPreview'

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-base-200">
      {/* Hero Section */}
      <section className="hero min-h-[70vh] bg-base-200">
        <div className="hero-content flex-col lg:flex-row-reverse max-w-7xl mx-auto px-4">
          {/* Preview */}
          <div className="w-full lg:w-1/2 flex justify-center">
            <AnimatedLogoPreview />
          </div>
          {/* Content */}
          <div className="w-full lg:w-1/2 text-center lg:text-left">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight">
              Create Beautiful Icon Logos in Seconds
            </h1>
            <p className="py-6 text-lg text-base-content/80">
              Design professional logos instantly with our easy-to-use
              icon-based logo creator. Choose from hundreds of icons, customize
              colors, and download in multiple formats.
            </p>
            <Link to="/create" className="btn btn-primary btn-lg">
              Start Creating{' '}
              <FontAwesomeIcon icon={faArrowRight} className="ml-2" />
            </Link>
            <div className="mt-4">
              <a
                href="https://www.producthunt.com/posts/logobe-st?embed=true&utm_source=badge-featured&utm_medium=badge&utm_souce=badge-logobe&#0045;st"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=964049&theme=dark&t=1747202905524"
                  alt="Logobe&#0046;st - Simple&#0032;and&#0032;free&#0032;online&#0032;logo&#0032;maker | Product Hunt"
                  style={{ width: '250px', height: '54px' }}
                  width="250"
                  height="54"
                />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-base-100">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">
            Why Choose Logo Best?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Feature 1 */}
            <div className="card bg-base-200 shadow-xl">
              <div className="card-body">
                <FontAwesomeIcon
                  icon={faBolt}
                  className="text-4xl text-primary mb-4"
                />
                <h3 className="card-title">Lightning Fast</h3>
                <p>
                  Create your logo in seconds, not hours. Our intuitive
                  interface makes logo design a breeze.
                </p>
              </div>
            </div>
            {/* Feature 2 */}
            <div className="card bg-base-200 shadow-xl">
              <div className="card-body">
                <FontAwesomeIcon
                  icon={faPalette}
                  className="text-4xl text-primary mb-4"
                />
                <h3 className="card-title">Full Customization</h3>
                <p>
                  Control every aspect of your logo - from colors and sizes to
                  borders and rotations.
                </p>
              </div>
            </div>
            {/* Feature 3 */}
            <div className="card bg-base-200 shadow-xl">
              <div className="card-body">
                <FontAwesomeIcon
                  icon={faDownload}
                  className="text-4xl text-primary mb-4"
                />
                <h3 className="card-title">Multiple Formats</h3>
                <p>
                  Download your logo in PNG or SVG format, perfect for any use
                  case.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-base-200">
        <div className="max-w-3xl mx-auto text-center px-4">
          <h2 className="text-3xl font-bold mb-6">
            Ready to Create Your Logo?
          </h2>
          <p className="mb-8 text-lg text-base-content/80">
            Join thousands of users who have created their perfect logo with
            Logo Best.
          </p>
          <Link to="/create" className="btn btn-primary btn-lg">
            Create Your Logo Now{' '}
            <FontAwesomeIcon icon={faArrowRight} className="ml-2" />
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer footer-center p-10 bg-base-300 text-base-content">
        <div>
          <p className="font-bold">Logo Best © 2024 - All rights reserved</p>
          <div className="flex gap-4">
            <a href="#" className="link link-hover">
              Privacy Policy
            </a>
            <a href="#" className="link link-hover">
              Terms of Service
            </a>
            <a href="mailto:support@logobe.st" className="link link-hover">
              Contact
            </a>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default LandingPage
